import { cn } from "../lib/utils";

type ChipVariant = "default" | "primary" | "success" | "warning" | "destructive" | "secondary";
type ChipSize = "sm" | "md" | "lg";

interface ChipProps {
  children: React.ReactNode;
  variant?: ChipVariant;
  size?: ChipSize;
  onRemove?: () => void;
  icon?: React.ReactNode;
  dot?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  style?: React.CSSProperties;
}

export function Chip({
  children,
  variant = "default",
  size = "md",
  onRemove,
  icon,
  dot = false,
  className,
  onClick,
  style,
}: ChipProps) {
  return (
    <span className={cn("chip", `chip-${variant}`, `chip-${size}`, className)} onClick={onClick} style={style}>
      {dot && <span className="chip-dot" />}
      {icon && <span className="chip-icon">{icon}</span>}
      <span className="chip-label">{children}</span>
      {onRemove && (
        <button
          className="chip-remove"
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          aria-label="Remove"
          type="button"
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </span>
  );
}
